import React from 'react'
import styles from './tip_box.less'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import { Avatar } from '@paypalcorp/pp-react'

class TipBox extends React.Component {
  static propTypes = {
    text: PropTypes.string,
  }

  render() {
    return (
      <div styleName="tip-wrapper">
        <Avatar icon="light-bulb" size="md" styleName="tip-icon" />
        <div styleName="tip-text">{this.props.text}</div>
      </div>
    )
  }
}

export default cssModules(TipBox, styles)
